module.exports = coreApis.componentApis.feeds.disableProfilePopup;